import { get } from '../index';

// Business-performance analytics behind the Dashboard → Analytics submenu.
// `companyId` is the super-admin company picker (ignored for other roles).
export const getBusinessAnalytics = (companyId) => {
  const qs = companyId ? `?companyId=${encodeURIComponent(companyId)}` : '';
  return get(`/analytics/business${qs}`);
};
